Bingo.GalleryCarousel = {};

Bingo.GalleryCarousel.init = () => {
    $('body').on('click', '.js-carousel_control', (event) => {
        $(event.target).parents().eq(1).find('.prevent-image-load')
            .each((index, element) => {
                const src = $(element).attr('data-src');
                $(element).addClass('picture-size-cover').css('background-image', `url( ${src} )`);
            });
    });
};
